export const themes = {
  default: {
    thRoot: 'flex flex-col',
    thImage:
      'bg-grey isolate order-first overflow-hidden rounded-12 transition-all duration-250 ease-in',
    thImageActive: 'opacity-75 scale-095',
  },
  short: {
    thRoot:
      'flex flex-col h-full isolate overflow-hidden relative rounded-12 shadow-sm transition-all duration-250 ease-in',
    thChildren: 'p-15 md:p-20 h-full',
    thRootActive: 'shadow-md',
    thImage:
      'bg-grey order-first overflow-hidden rounded-t-12 shrink-0 duration-250 ease-in transition-all',
  },
};
